import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  { path: '/login', component: () => import('../views/Login.vue') },
  {
    path: '/',
    component: () => import('../views/Layout.vue'),
    redirect: '/sign',
    children: [
      { path: 'sign', component: () => import('../views/SignManage.vue'), meta: { title: '签到管理', perm: 'sign' } },
      { path: 'student', component: () => import('../views/StudentManage.vue'), meta: { title: '学生管理', perm: 'student' } },
      { path: 'category', component: () => import('../views/CategoryManage.vue'), meta: { title: '分类管理', perm: 'category' } },
      { path: 'report', component: () => import('../views/ReportManage.vue'), meta: { title: '学习汇报', perm: 'report' } },
      { path: 'admin', component: () => import('../views/AdminManage.vue'), meta: { title: '员工管理', perm: 'admin' } },
      { path: 'task', component: () => import('../views/TaskManage.vue'), meta: { title: '员工任务表', perm: 'task' } },
      { path: 'my-task', component: () => import('../views/MyTask.vue'), meta: { title: '我的任务打卡', perm: 'my-task' } },
      { path: 'lead-add', component: () => import('../views/LeadAdd.vue'), meta: { title: '线索添加', perm: 'lead-add' } },
      { path: 'lead-list', component: () => import('../views/LeadList.vue'), meta: { title: '线索总揽', perm: 'lead-list' } },
      { path: 'lead-assign', component: () => import('../views/LeadAssign.vue'), meta: { title: '线索分配', perm: 'lead-assign' } },
      { path: 'lead-follow', component: () => import('../views/LeadFollow.vue'), meta: { title: '线索跟进', perm: 'lead-follow' } },
      { path: 'volunteer', component: () => import('../views/VolunteerGenerate.vue'), meta: { title: '志愿生成' } },
      { path: 'zhiyuan', component: () => import('../views/ZhiyuanQuery.vue'), meta: { title: '院校查询' } },
      { path: 'zhuanye', component: () => import('../views/ZhuanyeQuery.vue'), meta: { title: '专业查询' } },
      { path: 'password', component: () => import('../views/ChangePassword.vue'), meta: { title: '修改密码' } }
    ]
  }
];

const router = new VueRouter({ routes });

const hasPerm = (p) => {
  const perms = localStorage.getItem('admin_permissions') || '';
  return perms === '*' || perms.split(',').includes(p);
};

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('admin_token');
  if (to.path !== '/login' && !token) return next('/login');
  if (to.path === '/login' && token) return next('/');
  if (!token) return next();

  // 按权限控制路由访问
  if (to.meta && to.meta.perm && !hasPerm(to.meta.perm)) {
    const first = ['my-task', 'sign', 'task', 'admin'].find((k) => hasPerm(k));
    return next(first ? '/' + first : '/password');
  }
  next();
});

export default router;
